import { getLanguage } from './i18n.js';
import { getLocale } from '../i18n/locales.js';

/**
 * Locale-aware numbers, dates and language names for the active locale.
 * Digits stay Latin in every locale (`-u-nu-latn`), like every other number
 * the site interpolates; only separators, month names and word order change.
 */
const tag = () => `${getLocale(getLanguage()).htmlLang}-u-nu-latn`;

export const formatNumber = (value, options) => new Intl.NumberFormat(tag(), options).format(value);

/** `iso` is a calendar date (`2026-11-03`); it is read as UTC so no time zone shifts the day. */
export const formatDate = (iso) =>
  new Intl.DateTimeFormat(tag(), { dateStyle: 'long', timeZone: 'UTC' }).format(new Date(`${iso}T00:00:00Z`));

/** The name of a language in the active locale; unknown codes come back as the code. */
export const languageName = (code) => new Intl.DisplayNames([tag()], { type: 'language' }).of(code);
